import { DatePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component, EventEmitter,
  Input,
  OnDestroy,
  OnInit, Output
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { BaseSiteService, CmsService, GlobalMessageService, GlobalMessageType, LanguageService, RoutingService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { DataLayerService } from 'src/app/shared/services/data-layer.service';
import { RecaptchaService } from 'src/app/shared/services/recaptcha.service';
import { SharedService } from '../../../shared/services/shared.service';
import { CustomRegistrationService } from '../../custom-registration.service';
import {
  delTimeValue,
  globalErrorMsgEng,
  globalErrorMsgFr,
  siteLanguagesEng
} from '../../registration.constants';

const maxlengthFourty = 40;
const maxlengthChar = 256;
const maxlengthTwelve = 12;
const charlengthSix = 6;
const nameRegex = '[^@#!$%*()=]+$';
const faxRegex = '^[0-9]{3}-[0-9]{3}-[0-9]{4}$';
const phonepattern = '^[0-9]{3}-[0-9]{3}-[0-9]{4}$'

const emailRegexExp = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,15}$/;
// '^([A-Za-z0-9\\._-]+)@([A-Za-z0-9\\._-]+)\\.([A-Za-z\\.]{2,8})(\\.[A-Za-z\\.]{2,8})?$';

const primaryDataEmail = 'primaryData.email';
const primaryDataFax = 'primaryData.fax';
const invoiceContactEmail = 'invoiceNewContactData.email';
const invoiceContactFax = 'invoiceNewContactData.fax';
const invoiceContactPrimary = 'invoiceNewContactData.primaryContact2';
const shippingContactPrimary = 'shippingNewContactData.primaryContact3';
const shippingContactEmail = 'shippingNewContactData.email';
const shippingContactFax = 'shippingNewContactData.fax';

@Component({
  selector: 'app-contacts-information',
  templateUrl: './contacts-information.component.html',
  styleUrls: ['./contacts-information.component.scss'],

})
export class ContactsInformationComponent implements OnInit, OnDestroy {
  @Input() formDetails: any;
  @Input() multiFormData: any;
  @Output() pageHeader = new EventEmitter<any>();
  header: string;
  expirationDateBoolean: boolean = true;
  prevDateForExpiration: boolean = false;
  formData: any;
  baseSiteId: any;
  creditInvoice: string;
  cmsResponse: any;
  finalNeedAss: any;
  model: NgbDateStruct;
  model2: NgbDateStruct;
  deaValueValidation: any = "Valid";
  deaValueValidationforHIN: any = "Valid";
  contactsForm: FormGroup;
  contactTitle: any[] = [];
  contactRole: any[] = [];
  isPrimaryContact: boolean[] = [true, false];
  isPrimaryFlag: boolean = true;
  isInvoiceContact: boolean[] = [true, false];
  isShippingContact: boolean[] = [true, false];
  preferredContactMethod: string[] = ['INT', 'FAX'];
  accountRegisSub: Subscription;
  contactTitleSub: Subscription;
  contactRoleSub: Subscription;
  maxSelectionDate = new Date();
  dateFormat = 'DD/MM/YYYY';
  fromDate: any;
  errorMessageText: string = globalErrorMsgEng;
  timelist = delTimeValue;
  recaptchaEnabled = false;
  siteKey: string | null = null;
  subRecaptcha: Subscription;

  emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,15}$/;
   // /^([A-Za-z\d\._-]+)@([A-Za-z\d\._-]+)\.([A-Za-z\.]{2,8})(\.[A-Za-z\.]{2,8})?$/g;

  validationType: object;
  constructor(
    private readonly accountRegService: CustomRegistrationService,
    private readonly cdr: ChangeDetectorRef,
    private readonly sharedService: SharedService,
    private readonly user: UserAccountFacade,
    private readonly router: RoutingService,
    private readonly languageService: LanguageService,
    private readonly globalMessage: GlobalMessageService,
    private datePipe: DatePipe,
    private readonly cmsData: CmsService,
    private baseSiteService: BaseSiteService,
    private _dataLayerService: DataLayerService,
    private recaptchaService: RecaptchaService
  ) { }

  ngOnInit(): void {
    //GTM
    this._dataLayerService.addtoDataLayer('accReg_FormEvent', '', '', '', 'form_step', 'license');

    this.baseSiteService.getActive().pipe(take(1)).subscribe((res) => (this.baseSiteId = res));
    this.header = 'contacts';
    this.creditInvoice = 'invoiceTable';
    this.accountRegService.sectionChange.subscribe((sectionDetails) => {
      this.header = sectionDetails.header;
      this.cdr.detectChanges();
    });

    localStorage.setItem("section", "Contact");

    this.finalNeedAss =  this.cmsData.getComponentData('NeedAssistanceComponent');
   
    window.scroll(0, 0);
    this.languageService.getActive().subscribe((langRes) => {
      this.errorMessageText =
        langRes === siteLanguagesEng ? globalErrorMsgEng : globalErrorMsgFr;
    });
    this.validationType = {
      firstName: [
        Validators.required,
        Validators.pattern(nameRegex),
        Validators.maxLength(maxlengthFourty),
      ],
      lastName: [
        Validators.required,
        Validators.pattern(nameRegex),
        Validators.maxLength(maxlengthFourty),
      ],
      title: [Validators.required],
      role: [Validators.required],
      preferredContactMethod2: [Validators.required],
      email: [Validators.required, Validators.pattern(emailRegexExp)],
      confirmEmail: new FormControl(null, [
        Validators.required,
        // Validators.pattern(
        //   '^([A-Za-z0-9\\._-]+)@([A-Za-z0-9\\._-]+)\\.([A-Za-z\\.]{2,8})(\\.[A-Za-z\\.]{2,8})?$'
        // ),
        Validators.pattern(emailRegexExp),
        Validators.minLength(charlengthSix),
        Validators.maxLength(maxlengthChar),
      ]),
      stateLicense: [
        Validators.required
      ],
      dea: [
      ],
      deaName: [
      ],
      hin: [
      ],
      datepicker: [
        Validators.required
      ],
      phone: new FormControl(null, [Validators.maxLength(maxlengthTwelve)]),
      extension: new FormControl(null, [
        Validators.pattern('[0-9]*$'),
        Validators.maxLength(charlengthSix),
      ]),
    };
    this.accountRegService.getContactTitle({
      enumerationType: 'ContactTitle',
      fields: 'DEFAULT',
    });
    this.accountRegService.getContactRole({
      enumerationType: 'CustomerRole',
      fields: 'DEFAULT',
    });

    this.contactsForm = new FormGroup({
      // primaryContact: new FormControl(this.isPrimaryContact[0]),
      // invoiceContact: new FormControl(this.isInvoiceContact[1]),
      // shippingContact: new FormControl(false),
      primaryData: new FormGroup({
        firstName: new FormControl(null, [
          Validators.required,
          Validators.pattern(nameRegex),
          Validators.maxLength(maxlengthFourty),
        ]),
        firstName_repeat: new FormControl(null, [
          Validators.required,
          Validators.pattern(nameRegex),
          Validators.maxLength(maxlengthFourty),
        ]),
        lastName: new FormControl(null, [
          Validators.required,
          Validators.pattern(nameRegex),
          Validators.maxLength(maxlengthFourty),
        ]),
        lastname_repeat: new FormControl(null, [
          Validators.required,
          Validators.pattern(nameRegex),
          Validators.maxLength(maxlengthFourty),
        ]),
        title: new FormControl(null, [Validators.required]),
        title_repeat: new FormControl(null, [Validators.required]),
        role: new FormControl(null, [Validators.required]),
        role_repeat: new FormControl(null),
        dea: new FormControl(null),
        dea_repeat: new FormControl(null),
        deaName: new FormControl(null, [Validators.maxLength(maxlengthFourty)]),
        deaName_repeat: new FormControl(null, [Validators.maxLength(maxlengthFourty)]),
        hin: new FormControl(null),
        hin_repeat: new FormControl(null),
        stateLicense: new FormControl(null, [Validators.required, Validators.pattern(nameRegex)]),
        stateLicense_repeat: new FormControl(null),
        datepicker: new FormControl(null, Validators.required),
        datepicker_repeat: new FormControl(null),
        // preferredContactMethod: new FormControl(
        //   this.preferredContactMethod[0],
        //   [Validators.required]
        // ),
        email: new FormControl(null, [
          Validators.required,
          Validators.pattern(emailRegexExp),
        ]),
        email_repeat: new FormControl(null, [
          Validators.required,
          Validators.pattern(emailRegexExp),
        ]),
        confirmEmail: new FormControl(null, [
          Validators.required,
          Validators.pattern(emailRegexExp),
        ]),
        confirmEmail_repeat: new FormControl(null, [
          Validators.required,
          Validators.pattern(emailRegexExp),
        ]),
        fax: new FormControl(null, [
          Validators.pattern(faxRegex),
          Validators.maxLength(maxlengthTwelve),
        ]),
        phone: new FormControl(null, [
          Validators.pattern(faxRegex),
          Validators.maxLength(maxlengthTwelve),
        ]),
        phone_repeat: new FormControl(null, [
          Validators.pattern(faxRegex),
          Validators.maxLength(maxlengthTwelve),
        ]),
        extension: new FormControl(null, [
          Validators.pattern('[0-9]*$'),
          Validators.maxLength(charlengthSix),
        ]),
        extension_repeat: new FormControl(null, [
          Validators.pattern('[0-9]*$'),
          Validators.maxLength(charlengthSix),
        ]),
        // sameAsBillingAddress: new FormControl(null,
        //   Validators.required
        // ),
        captcha: new FormControl(null, Validators.required),
        sameAsBillingAddress: new FormControl(null
        ),
      }),

      // invoiceNewContactData: new FormGroup({
      //   firstName: new FormControl(null),
      //   lastName: new FormControl(null),
      //   title: new FormControl(null),
      //   stateLicense: new FormControl(null, [Validators.required]),
      //   datepicker: new FormControl(null),
      //   role: new FormControl(null),
      //   preferredContactMethod2: new FormControl(
      //     this.preferredContactMethod[0]
      //   ),
      //   email: new FormControl(null),
      //   fax: new FormControl(null, [
      //     Validators.pattern(faxRegex),
      //     Validators.maxLength(maxlengthTwelve),
      //   ]),
      //   phone: new FormControl(null, [
      //     Validators.pattern(faxRegex),
      //     Validators.maxLength(maxlengthTwelve),
      //   ]),
      //   extension: new FormControl(null, [
      //     Validators.pattern('[0-9]*$'),
      //     Validators.maxLength(charlengthSix),
      //   ]),
      //   primaryContact2: new FormControl(this.isPrimaryContact[0]),
      //   invoiceContact: new FormControl(this.isInvoiceContact[0]),
      //   shippingContact: new FormControl(false),
      // }),
      // shippingNewContactData: new FormGroup({
      //   firstName: new FormControl(null),
      //   lastName: new FormControl(null),
      //   title: new FormControl(null),
      //   stateLicense: new FormControl(null, [Validators.required]),
      //   datepicker: new FormControl(null),
      //   role: new FormControl(null),
      //   preferredContactMethod3: new FormControl(
      //     this.preferredContactMethod[0]
      //   ),
      //   email: new FormControl(null),
      //   fax: new FormControl(null, [
      //     Validators.pattern(faxRegex),
      //     Validators.maxLength(maxlengthTwelve),
      //   ]),
      //   phone: new FormControl(null, [
      //     Validators.pattern(faxRegex),
      //     Validators.maxLength(maxlengthTwelve),
      //   ]),
      //   primaryContact3: new FormControl(this.isPrimaryContact[0]),
      //   invoiceContact: new FormControl(false),
      //   shippingContact: new FormControl(this.isShippingContact[0]),
      // }),
    });

    this.contactTitleSub = this.accountRegService.contactTitleData$.subscribe(
      (response) => {
        if (response !== false) {
          this.contactTitle = response;
        }
      }
    );

    this.contactRoleSub = this.accountRegService.contactRoleData$.subscribe(
      (response) => {
        if (response !== false) {
          this.contactRole = response;
        }
      }
    );

    this.contactsForm?.get('primaryData.preferredContactMethod')
      ?.valueChanges.subscribe((value) => {
        this.primaryPreferredContactEvaluation(value);
      });

    this.contactsForm?.get('invoiceNewContactData.preferredContactMethod2')
      ?.valueChanges.subscribe((value) => {
        this.invoicePreferredContactEvaluation(value);
      });

    this.contactsForm?.get(invoiceContactPrimary)
      ?.valueChanges.subscribe((value) => {
        if (value === this.isPrimaryContact[0]) {
          this.removeValidators(
            this.contactsForm.get('invoiceNewContactData') as FormGroup
          );
        } else if (value === this.isPrimaryContact[1]) {
          this.addValidators(
            this.contactsForm.get('invoiceNewContactData') as FormGroup
          );
        } else {
          // no change
        }
      });

    this.contactsForm?.get('invoiceContact')?.valueChanges.subscribe((value) => {
      if (value === this.isPrimaryContact[1]) {
        this.removeValidators(
          this.contactsForm.get('invoiceNewContactData') as FormGroup
        );
      } else if (
        value === true &&
        this.contactsForm.get(invoiceContactPrimary).value === false
      ) {
        this.addValidators(
          this.contactsForm.get('invoiceNewContactData') as FormGroup
        );
      } else {
        // no change
      }
    });

    this.contactsForm?.get('shippingContact')?.valueChanges.subscribe((value) => {
      if (value === this.isPrimaryContact[1]) {
        this.removeValidators(
          this.contactsForm.get('shippingNewContactData') as FormGroup
        );
      } else if (
        value === true &&
        this.contactsForm.get(shippingContactPrimary).value === false
      ) {
        this.addValidators(
          this.contactsForm.get('shippingNewContactData') as FormGroup
        );
      } else {
        // no change
      }
    });

    this.contactsForm?.get(shippingContactPrimary)
      ?.valueChanges.subscribe((value) => {
        if (value === this.isPrimaryContact[0]) {
          this.removeValidators(
            this.contactsForm.get('shippingNewContactData') as FormGroup
          );
        } else if (value === this.isPrimaryContact[1]) {
          this.addValidators(
            this.contactsForm.get('shippingNewContactData') as FormGroup
          );
        } else {
          // no change
        }
      });

    this.contactsForm?.get('shippingNewContactData.preferredContactMethod3')
      ?.valueChanges.subscribe((value) => {
        this.shippingPreferredContactEvaluation(value);
      });

    this.subRecaptcha = this.recaptchaService.isEnabled$().subscribe((enabled) => {
      this.recaptchaEnabled = enabled;
      this.siteKey = this.recaptchaService.getSiteKey();
      if (!enabled) {
        this.contactsForm.get('captcha')?.clearValidators();
        this.contactsForm.get('captcha')?.updateValueAndValidity();
      }
    });

  }

  public removeValidators(form: FormGroup) {
    for (const key in form.controls) {
      if (!!this.validationType[key]) {
        form.get(key).clearValidators();
        form.get(key).updateValueAndValidity();
      }
    }
  }

  dateValidation(e) {
    var expDate_val = e.target.value;
    if (e.target.value.length > 0 && e.target.value.length < 10) {
      this.expirationDateBoolean = false;
      this.prevDateForExpiration = false;
      this.contactsForm.controls.primaryData.get('datepicker').setErrors({ 'incorrect': true });
      this.contactsForm.setErrors({ 'invalid': true });
    }
    else if (e.target.value.length == 0) {
      this.expirationDateBoolean = true;
    }
    else {
      var ArrForDate_exp = expDate_val.split("/");
      if (new Date(e.target.value).getTime() <= Date.now()) {
        this.prevDateForExpiration = true;
        this.expirationDateBoolean = true;
        this.contactsForm.controls.primaryData.get('datepicker').setErrors({ 'incorrect': true });
        this.contactsForm.setErrors({ 'invalid': true });
        //this.contactsForm.controls.primaryData.get('datepicker').setValue('');
      }
      else {
        this.prevDateForExpiration = false;
        if (ArrForDate_exp[0] == '00' || ArrForDate_exp[1] == '00' || ArrForDate_exp[2] == '0000') {
          this.expirationDateBoolean = false;
          this.contactsForm.controls.primaryData.get('datepicker').setErrors({ 'incorrect': true });
          this.contactsForm.setErrors({ 'invalid': true });
        }
        else {
          if (ArrForDate_exp[0] > 12 || ArrForDate_exp[1] > 31 || ArrForDate_exp[2] > 2050) {
            this.expirationDateBoolean = false;
            this.contactsForm.controls.primaryData.get('datepicker').setErrors({ 'incorrect': true });
            this.contactsForm.setErrors({ 'invalid': true });
          }
          else {
            this.expirationDateBoolean = true;
            this.contactsForm.controls.primaryData.get('datepicker').setErrors(null);
            this.contactsForm.setErrors(null);
          }
        }
      }



    }
  }

  public addValidators(form: FormGroup) {
    for (const key in form.controls) {
      if (!!this.validationType[key]) {
        form.get(key).setValidators(this.validationType[key]);
        form.get(key).updateValueAndValidity();
      }
    }
  }

  validateHIN(e) {

    if (e.target.value.length == 0) {
      this.deaValueValidationforHIN = "Valid";
    }
    else {
      this.deaValueValidationforHIN = "notValid";
      if (e.target.value.length == 9) {
        this.deaValueValidationforHIN = "Valid";
      }
    }
  }


  validatepattrn(e) {
    if (e.target.value.length == 0) {
      this.deaValueValidation = "Valid";
    }
    else {
      this.deaValueValidation = "notValid";
      if (e.target.value.length == 9) {
        var firstChar = e.target.value.substring(0, 1);
        var first2Chars = e.target.value.substring(1, 2);
        var thirdPos = e.target.value.substring(2, 3);
        var forthPos = e.target.value.substring(3, 4);
        var fifthPos = e.target.value.substring(4, 5);
        var sixthPos = e.target.value.substring(5, 6);
        var seventhPos = e.target.value.substring(6, 7);
        var eightthPos = e.target.value.substring(7, 8);
        var ninthPos = e.target.value.substring(8, 9);

        if (/[a-z]/i.test(first2Chars) && /[a-z]/i.test(firstChar)) {
          if (/[0-9]/i.test(thirdPos) && /[0-9]/i.test(thirdPos) && /[0-9]/i.test(forthPos) && /[0-9]/i.test(fifthPos) && /[0-9]/i.test(sixthPos) && /[0-9]/i.test(seventhPos) && /[0-9]/i.test(eightthPos) && /[0-9]/i.test(ninthPos)) {
            this.deaValueValidation = "Valid";
          }

        }
        else {
          this.deaValueValidation = "notValid";
        }
      }
    }



  }

  primaryPreferredContactEvaluation(value) {
    if (value === this.preferredContactMethod[0]) {
      this.contactsForm
        .get(primaryDataEmail)
        .setValidators([
          Validators.required,
          Validators.pattern(emailRegexExp),
        ]);
      this.contactsForm.get(primaryDataFax).clearValidators();
      this.contactsForm
        .get(primaryDataFax)
        .setValidators([
          Validators.pattern(faxRegex),
          Validators.maxLength(maxlengthTwelve),
        ]);
      this.contactsForm.get(primaryDataEmail).updateValueAndValidity();
      this.contactsForm.get(primaryDataFax).updateValueAndValidity();
    } else if (value === this.preferredContactMethod[1]) {
      this.contactsForm
        .get(primaryDataFax)
        .setValidators([
          Validators.required,
          Validators.pattern(faxRegex),
          Validators.maxLength(maxlengthTwelve),
        ]);
      this.contactsForm.get(primaryDataEmail).clearValidators();
      this.contactsForm
        .get(primaryDataEmail)
        .setValidators([Validators.pattern(emailRegexExp)]);
      this.contactsForm.get(primaryDataFax).updateValueAndValidity();
      this.contactsForm.get(primaryDataEmail).updateValueAndValidity();
    } else {
      // no change
    }
  }

  invoicePreferredContactEvaluation(value) {
    if (value === this.preferredContactMethod[0]) {
      this.contactsForm
        .get(invoiceContactEmail)
        .setValidators([
          Validators.required,
          Validators.pattern(emailRegexExp),
        ]);
      this.contactsForm.get(invoiceContactFax).clearValidators();
      this.contactsForm
        .get(invoiceContactFax)
        .setValidators([
          Validators.pattern(faxRegex),
          Validators.maxLength(maxlengthTwelve),
        ]);
      this.contactsForm.get(invoiceContactEmail).updateValueAndValidity();
      this.contactsForm.get(invoiceContactFax).updateValueAndValidity();
    } else if (value === this.preferredContactMethod[1]) {
      this.contactsForm
        .get(invoiceContactFax)
        .setValidators([
          Validators.required,
          Validators.pattern(faxRegex),
          Validators.maxLength(maxlengthTwelve),
        ]);
      this.contactsForm.get(invoiceContactEmail).clearValidators();
      this.contactsForm
        .get(invoiceContactEmail)
        .setValidators([Validators.pattern(emailRegexExp)]);
      this.contactsForm.get(invoiceContactFax).updateValueAndValidity();
      this.contactsForm.get(invoiceContactEmail).updateValueAndValidity();
    } else {
      // no change
    }
  }

  shippingPreferredContactEvaluation(value) {
    if (value === this.preferredContactMethod[0]) {
      this.contactsForm
        .get(shippingContactEmail)
        .setValidators([
          Validators.required,
          Validators.pattern(emailRegexExp),
        ]);
      this.contactsForm.get(shippingContactFax).clearValidators();
      this.contactsForm
        .get(shippingContactFax)
        .setValidators([
          Validators.pattern(faxRegex),
          Validators.maxLength(maxlengthTwelve),
        ]);
      this.contactsForm.get(shippingContactEmail).updateValueAndValidity();
      this.contactsForm.get(shippingContactFax).updateValueAndValidity();
    } else if (value === this.preferredContactMethod[1]) {
      this.contactsForm
        .get(shippingContactFax)
        .setValidators([
          Validators.required,
          Validators.pattern(faxRegex),
          Validators.maxLength(maxlengthTwelve),
        ]);
      this.contactsForm.get(shippingContactEmail).clearValidators();
      this.contactsForm
        .get(shippingContactEmail)
        .setValidators([Validators.pattern(emailRegexExp)]);
      this.contactsForm.get(shippingContactFax).updateValueAndValidity();
      this.contactsForm.get(shippingContactEmail).updateValueAndValidity();
    } else {
      // no change
    }
  }

  back() {
    const shippingDetails = {
      header: 'shippingDetails',
      form: this.formDetails,
      forms: this.formDetails,
    };
    this.pageHeader.emit(shippingDetails);
    this.accountRegService.sectionChange.next(shippingDetails);
  }

  showCaptchaErrorMsg = false;
  createAccount() {
    this.showCaptchaErrorMsg = this.contactsForm.controls.primaryData['controls'].captcha.errors?.required && true;
    localStorage.setItem("contactDetails", JSON.stringify(this.contactsForm.value.primaryData));
    this.replicateForm("Y");
    if (!this.isPrimaryFlag) {
      if (this.contactsForm.value.primaryData.stateLicense_repeat != null && this.contactsForm.value.primaryData.stateLicense != null && this.contactsForm.value.primaryData.email != null && this.contactsForm.value.primaryData.email_repeat != null && this.contactsForm.value.primaryData.confirmEmail != null && this.contactsForm.value.primaryData.confirmEmail_repeat != null && this.contactsForm.value.primaryData.datepicker != null && this.contactsForm.value.primaryData.datepicker_repeat != null && this.contactsForm.value.primaryData.firstName != null && this.contactsForm.value.primaryData.firstName_repeat != null && this.contactsForm.value.primaryData.lastName != null && this.contactsForm.value.primaryData.lastName_repeat != null && this.contactsForm.value.primaryData.title != null && this.contactsForm.value.primaryData.title_repeat != null) {
        this.contactsForm.value.primaryData.status = "VALID";
      }
      else {
        this.contactsForm.value.primaryData.status = "INVALID";
      }
    }
    else if (this.isPrimaryFlag) {
        if (this.contactsForm.value.primaryData.stateLicense != null && this.contactsForm.value.primaryData.email != null && this.contactsForm.value.primaryData.confirmEmail != null && this.contactsForm.value.primaryData.datepicker != null && this.contactsForm.value.primaryData.firstName != null && this.contactsForm.value.primaryData.lastName != null && this.contactsForm.value.primaryData.title != null &&
          this.contactsForm.value.primaryData.captcha != null) {
        this.contactsForm.value.primaryData.status = "VALID";
      }
      else {
        this.contactsForm.value.primaryData.status = "INVALID";
      }
    }


    if (this.contactsForm.valid) {
      var dateValueforSL = this.datePipe.transform(this.contactsForm.value.primaryData.datepicker, 'MM/dd/yyyy');
      var dateValueforSL_repeat
      if (dateValueforSL_repeat !== undefined) {
        dateValueforSL_repeat = this.contactsForm.value.primaryData.datepicker_repeat.month + "/" + this.contactsForm.value.primaryData.datepicker_repeat.day + "/" + this.contactsForm.value.primaryData.datepicker_repeat.year;
      } else {
        dateValueforSL_repeat = "";
      }
      this.multiFormData.contacts = [this.contactsForm.value.primaryData];
      this.contactsForm.markAllAsTouched();
      //this.organizeData();
      const formData_For_Shipping = JSON.parse(localStorage.getItem("billingFormDetails"));
      var deliveryHrs = [];
      var billFromDet = JSON.parse(localStorage.getItem("billingFormDetails"));
      var obj_DH;
      if (billFromDet.mondayFromTime != null && billFromDet.mondayToTime != null) {

        var matchedFromTime = this.timelist.find(e => e.id === billFromDet.mondayFromTime);
        var matchedToTime = this.timelist.find(e => e.id === billFromDet.mondayToTime);
        obj_DH = {
          "day": "MONDAY",
          "fromTime": matchedFromTime.name,
          "toTime": matchedToTime.name
        }
        deliveryHrs.push(obj_DH);
      }

      if (billFromDet.tuesFromTime != null && billFromDet.tuesToTime != null) {

        var matchedFromTime = this.timelist.find(e => e.id === billFromDet.tuesFromTime);
        var matchedToTime = this.timelist.find(e => e.id === billFromDet.tuesToTime);
        obj_DH = {
          "day": "TUESDAY",
          "fromTime": matchedFromTime.name,
          "toTime": matchedToTime.name
        }
        deliveryHrs.push(obj_DH);
      }

      if (billFromDet.wedFromTime != null && billFromDet.wedToTime != null) {

        var matchedFromTime = this.timelist.find(e => e.id === billFromDet.wedFromTime);
        var matchedToTime = this.timelist.find(e => e.id === billFromDet.wedToTime);
        obj_DH = {
          "day": "WEDNESDAY",
          "fromTime": matchedFromTime.name,
          "toTime": matchedToTime.name
        }
        deliveryHrs.push(obj_DH);
      }

      if (billFromDet.thursFromTime != null && billFromDet.thursToTime != null) {

        var matchedFromTime = this.timelist.find(e => e.id === billFromDet.thursFromTime);
        var matchedToTime = this.timelist.find(e => e.id === billFromDet.thursToTime);
        obj_DH = {
          "day": "THURSDAY",
          "fromTime": matchedFromTime.name,
          "toTime": matchedToTime.name
        }
        deliveryHrs.push(obj_DH);
      }

      if (billFromDet.fridayFromTime != null && billFromDet.fridayToTime != null) {

        var matchedFromTime = this.timelist.find(e => e.id === billFromDet.fridayFromTime);
        var matchedToTime = this.timelist.find(e => e.id === billFromDet.fridayToTime);
        obj_DH = {
          "day": "FRIDAY",
          "fromTime": matchedFromTime.name,
          "toTime": matchedToTime.name
        }
        deliveryHrs.push(obj_DH);
      }



      var address = [];
      var obj_shipping = {
        "facilityName": formData_For_Shipping?.facilityName,
        "legalName": formData_For_Shipping?.facilityName2,
        "attention": formData_For_Shipping?.attention,
        "practiceOrFacilityType": formData_For_Shipping?.practiceOrFacilityType,
        "billingAddress": false,
        "country": {
          "isocode": formData_For_Shipping?.region.isocode,
          "name": formData_For_Shipping?.region.name
        },
        "deliveryHours": deliveryHrs,
        "email": formData_For_Shipping?.email,
        "extension": formData_For_Shipping.extension != null ? formData_For_Shipping.extension : "",
        "line1": formData_For_Shipping?.line1,
        "line2": formData_For_Shipping?.line2,
        "phone": formData_For_Shipping?.phone,

        "town": formData_For_Shipping?.town,
        "postalCode": formData_For_Shipping?.postalCode,
        "region": {
          //"countryIso": formData_For_Shipping?.region.countryIso,
          "countryIso": "US",
          "isocode": formData_For_Shipping?.region.isocode,
          "isocodeShort": formData_For_Shipping?.region.isocode,
          "name": formData_For_Shipping?.region.name
        },

        "shippingAddress": true,
        "financialResponsible": false
      };
      address.push(obj_shipping);
      var shippingDetails = JSON.parse(localStorage.getItem("finalBillingDetails"));

      //address.push(formData.billing[0])
      var obj_billing = {
        "facilityName": shippingDetails["facilityName"],
        "legalName": shippingDetails["facilityName2"],
        "attention": shippingDetails["attention"],
        "practiceOrFacilityType": formData_For_Shipping?.practiceOrFacilityType,
        "billingAddress": true,
        "country": {
          "isocode": shippingDetails["region"].isocode,
          //"name": shippingDetails["region"].isocode
          "name": shippingDetails["region"].name
        },
        "deliveryHours": [],
        "email": shippingDetails["email"],
        "extension": shippingDetails["extension"] != null ? shippingDetails["extension"] : "",
        "line1": shippingDetails["line1"],
        "line2": shippingDetails["line2"],
        "phone": shippingDetails["phone"],

        "town": shippingDetails["town"],
        "postalCode": shippingDetails["postalCode"],
        "region": {
          //"countryIso": shippingDetails["region"].isocode,
          "countryIso": 'US',
          "isocode": shippingDetails["region"].isocode,
          "isocodeShort": shippingDetails["region"].isocode,
          //"name": shippingDetails["region"].isocode
          "name": shippingDetails["region"].name
        },

        "shippingAddress": false,
        "financialResponsible": !shippingDetails["yellowFeverForShippingAddr"] ? false : true,
      }

      if (!shippingDetails["sameAsBillingAddress"]) {
        address.push(obj_billing)
      }


      // if (localStorage.getItem("replicateForm")) {
      var obj_financiallyresponsible = {
        "facilityName": localStorage.getItem("replicateForm") ? shippingDetails["facilityName_repeat"] : shippingDetails["facilityName"],
        "legalName": localStorage.getItem("replicateForm") ? shippingDetails["facilityName_repeat2"] : shippingDetails["facilityName2"],
        "attention": shippingDetails["attention_repeat"],
        "practiceOrFacilityType": formData_For_Shipping?.practiceOrFacilityType,
        "billingAddress": false,
        "country": {
          "isocode": localStorage.getItem("replicateForm") ? shippingDetails["region_repeat"].isocode : shippingDetails["region"].isocode,
          //"countryIso": localStorage.getItem("replicateForm") ? shippingDetails["region_repeat"].isocode : shippingDetails["region"].isocode,
          "countryIso": localStorage.getItem("replicateForm") ? shippingDetails["region_repeat"].name : shippingDetails["region"].name,
        },
        "deliveryHours": [],
        "email": "",
        "extension": shippingDetails["extension_repeat"] != null ? shippingDetails["extension_repeat"] : "",
        "line1": localStorage.getItem("replicateForm") ? shippingDetails["line1_repeat"] : shippingDetails["line1"],
        "line2": localStorage.getItem("replicateForm") ? shippingDetails["line2_repeat"] : shippingDetails["line2"],
        "phone": localStorage.getItem("replicateForm") ? shippingDetails["phone_repeat"] : shippingDetails["phone"],

        "town": localStorage.getItem("replicateForm") ? shippingDetails["town_repeat"] : shippingDetails["town"],
        "postalCode": localStorage.getItem("replicateForm") ? shippingDetails["postalCode_repeat"] : shippingDetails["postalCode"],
        "region": {
          //"countryIso": localStorage.getItem("replicateForm") ? shippingDetails["region_repeat"].isocode : shippingDetails["region"].isocode,
          "countryIso": 'US',
          "isocode": localStorage.getItem("replicateForm") ? shippingDetails["region_repeat"].isocode : shippingDetails["region"].isocode,
          "isocodeShort": localStorage.getItem("replicateForm") ? shippingDetails["region_repeat"].isocode : shippingDetails["region"].isocode,
          //"name": localStorage.getItem("replicateForm") ? shippingDetails["region_repeat"].isocode : shippingDetails["region"].isocode
          "name": localStorage.getItem("replicateForm") ? shippingDetails["region_repeat"].name : shippingDetails["region"].name
        },

        "shippingAddress": false,
        "financialResponsible": true
      }

      // else {
      //   var obj_financiallyresponsible = {
      //     "facilityName": formData.billing[0].facilityName,
      //     "legalName": formData.billing[0].facilityName,
      //     "attention": "",
      //     "practiceOrFacilityType": formData.billing[0].practiceOrFacilityType,
      //     "billingAddress": true,
      //     "country": {
      //       "isocode": formData.billing[0].region.isocode,
      //       "countryIso": formData.billing[0].region.countryIso
      //     },
      //     "deliveryHours": [],
      //     "email": "tesbi1@mail.com",
      //     "extension": "5454542",
      //     "line1": formData.billing[0].line1,
      //     "line2": formData.billing[0].line2,
      //     "phone": formData.billing[0].phone,

      //     "town": formData.billing[0].town,
      //     "postalCode": formData.billing[0].postalCode,
      //     "region": {
      //       "countryIso": formData.billing[0].region.countryIso,
      //       "isocode": formData.billing[0].region.isocode,
      //       "isocodeShort": formData.billing[0].region.isocode,
      //       "name": "California"
      //     },

      //     "shippingAddress": false,
      //     "financialResponsible": true
      //   }
      // }
      if (!shippingDetails["yellowFeverForShippingAddr"]) {
        address.push(obj_financiallyresponsible);
      }


      var contactDetails = JSON.parse(localStorage.getItem("contactDetails"))
      var contacts = [];
      var obj_contacts = {
        "stateLicense": contactDetails.stateLicense,
        "stateLicenseExp": dateValueforSL,
        "hin": contactDetails.hin != null ? contactDetails.hin : "",
        "deaName": contactDetails.deaName != null ? contactDetails.deaName : "",
        "dea": contactDetails.dea != null ? contactDetails.dea : "",
        "email": contactDetails.email != '' ? contactDetails.email : "",
        "firstName": contactDetails.firstName != '' ? contactDetails.firstName : "",
        "lastName": contactDetails.lastName != '' ? contactDetails.lastName : "",
        "phone": contactDetails.phone != '' ? contactDetails.phone : "",
        "extension": contactDetails.extension != null ? contactDetails.extension : "",
        //"primaryContact": !this.isPrimaryFlag ? false : true,
        "primaryContact": true,
        "title": contactDetails.title != '' ? contactDetails.title : "",
        "role": contactDetails.role != '' ? contactDetails.role : "",
        "orderCreationPlan":  formData_For_Shipping?.orderCreationPlan,
        "contractGroupName":  formData_For_Shipping?.contractGroupName
      }

      // if (!this.isPrimaryFlag) {

      //   var obj_contacts_repeat = {
      //     "stateLicense": contactDetails.stateLicense_repeat,
      //     "stateLicenseExp": dateValueforSL_repeat,
      //     "hin": contactDetails.hin_repeat != null ? contactDetails.hin_repeat : "",
      //     "deaName": contactDetails.deaName_repeat != null ? contactDetails.deaName_repeat : "",
      //     "dea": contactDetails.dea_repeat != null ? contactDetails.dea_repeat : "",
      //     "email": contactDetails.email_repeat != '' ? contactDetails.email_repeat : "",
      //     "firstName": contactDetails.firstName_repeat != '' ? contactDetails.firstName_repeat : "",
      //     "lastName": contactDetails.lastName_repeat != '' ? contactDetails.lastName_repeat : "",
      //     "phone": contactDetails.phone_repeat != '' ? contactDetails.phone_repeat : "",
      //     "extension": contactDetails.extension_repeat != null ? contactDetails.extension_repeat : "",
      //     "primaryContact": false,
      //     "title": contactDetails.title_repeat != '' ? contactDetails.title_repeat : "",
      //     "role": contactDetails.role_repeat != '' ? contactDetails.role_repeat : "",
      //   }
      //   contacts.push(obj_contacts_repeat);
      // }



      contacts.push(obj_contacts);


      if (address.length < 2) {
        address.forEach(el => {
          el.billingAddress = true;
          el.financialResponsible = true;
          el.shippingAddress = true;
        })
      }
      if (address.length > 2) {
        address.forEach(function callback(value, index) {
          if (index == 0) {
            value.shippingAddress = true;
            value.billingAddress = false;
            value.financialResponsible = false;
          }
          if (index == 1) {
            value.shippingAddress = false;
            value.billingAddress = true;
            value.financialResponsible = false;
          }
          if (index == 2) {
            value.shippingAddress = false;
            value.billingAddress = false;
            value.financialResponsible = true;
          }
        })
      }
      else {

        address.forEach(function callback(value, index) {

          if (index == 0) {
            value.shippingAddress = true;
            value.billingAddress = shippingDetails["sameAsBillingAddress"] ? true : false;
            value.financialResponsible = shippingDetails["yellowFeverForShippingAddr"] ? true : false;
          }
          if (index == 1) {
            value.shippingAddress = false;
            value.billingAddress = shippingDetails["sameAsBillingAddress"] ? false : true;
            value.financialResponsible = shippingDetails["yellowFeverForShippingAddr"] ? false : true;
          }

        })


      }





      // if (shippingDetails["sameAsBillingAddress"]) {
      //   address.forEach(el => {
      //     el.billingAddress = true;
      //   })
      // }
      // if (shippingDetails["yellowFeverForShippingAddr"]) {
      //   address.forEach(el => {
      //     if (address.length < 2) {
      //       el.financialResponsible = true;
      //     }
      //     else {
      //       if (!el.billingAddress) {
      //         el.financialResponsible = false;
      //       }
      //     }

      //   })
      // }
      // if (!shippingDetails["yellowFeverForShippingAddr"]) {
      //   address.forEach(el => {
      //     if (el.billingAddress) {
      //       el.financialResponsible = true;
      //     }
      //   })
      // }


      var obj = { "addresses": address, "contacts": contacts, 'captchaToken': this.contactsForm.value.primaryData.captcha };
      this.accountRegisSub = this.accountRegService
        .postAccountRegistration(obj)
        .subscribe((res) => {
          if (res === null) {
            const contactDetails = { header: 'confirmation' };
            !!localStorage.getItem('accountConfirmationData')
              ? localStorage.removeItem('accountConfirmationData')
              : null;
            localStorage.setItem(
              'accountConfirmationData',
              JSON.stringify(contactDetails)
            );
            this.sharedService.setSessionStorage(
              'accountConfirmationData',
              contactDetails
            );
            this.router.goByUrl('/register/confirm');
            //GTM
            this._dataLayerService.addtoDataLayer('accReg_FormEvent', '', '', '', 'form_submit', 'license');

          }
          else if (res["status"] == 'success') {
            this.router.goByUrl('/register/confirm');
            //GTM
            this._dataLayerService.addtoDataLayer('accReg_FormEvent', '', '', '', 'form_submit', 'license');
          }
          else {
            this.globalMessage.add("Something went wrong", GlobalMessageType.MSG_TYPE_ERROR);
            this._dataLayerService.addtoDataLayer('accReg_FormEvent', '', '', '', 'form_error', 'license', 'form');
          }

        });
    }
    else {


      window.scroll(0, 0);
      this.contactsForm.updateValueAndValidity();
      this.contactsForm.markAllAsTouched();
      this.globalMessage.add(
        this.errorMessageText,
        GlobalMessageType.MSG_TYPE_ERROR
      );
      this._dataLayerService.addtoDataLayer('accReg_FormEvent', '', '', '', 'form_error', 'license', 'tab')
    }

  }

  organizeData() {
    this.formDetails.contacts = [];
    const pContacts = {
      primaryContact: false,
      invoiceContact: false,
      shippingContact: false,
    };
    pContacts.primaryContact = this.contactsForm.get('primaryContact').value;
    pContacts.invoiceContact =
      !!this.contactsForm.get('invoiceContact').value &&
        !this.contactsForm.get(invoiceContactPrimary).value
        ? false
        : this.contactsForm.get('invoiceContact').value;
    pContacts.shippingContact =
      !!this.contactsForm.get('shippingContact').value &&
        !this.contactsForm.get(shippingContactPrimary).value
        ? false
        : this.contactsForm.get('shippingContact').value;
    const primaryObj = {
      ...pContacts,
      ...this.contactsForm.get('primaryData').value,
    };
    primaryObj.email = this.contactsForm.get(primaryDataEmail).value;
    primaryObj.fax = this.contactsForm.get(primaryDataFax).value;
    this.formDetails.contacts.push(primaryObj);
    const propertyNames = Object.keys(
      this.contactsForm.get('primaryData').value
    );
    if (!!propertyNames && propertyNames.length > 0) {
      const arr = ['preferredContactMethod'];
      for (const elem of arr) {
        const ind = propertyNames.indexOf(elem);
        if (ind >= 0) {
          propertyNames.splice(ind, 1);
        }
      }
    }
    this.organizeInvoiceContactData(propertyNames);
    this.organizeShippingContactData(propertyNames);
  }

  organizeInvoiceContactData(propertyNames) {
    if (
      !!this.contactsForm.get('invoiceContact').value &&
      !this.contactsForm.get(invoiceContactPrimary).value
    ) {
      const obj = {
        primaryContact: false,
        shippingContact: false,
        invoiceContact: true,
        preferredContactMethod: '',
      };
      for (const key of propertyNames) {
        obj[key] = this.contactsForm.get(`invoiceNewContactData.${key}`).value;
      }
      obj.preferredContactMethod = this.contactsForm.get(
        'invoiceNewContactData.preferredContactMethod2'
      ).value;
      obj['email'] = this.contactsForm.get(invoiceContactEmail).value;
      obj['fax'] = this.contactsForm.get(invoiceContactFax).value;
      this.formDetails.contacts.push(obj);
    }
  }

  organizeShippingContactData(propertyNames) {
    if (
      !!this.contactsForm.get('shippingContact').value &&
      !this.contactsForm.get(shippingContactPrimary).value
    ) {
      const obj = {
        primaryContact: false,
        shippingContact: true,
        invoiceContact: false,
        preferredContactMethod: '',
      };
      for (const key of propertyNames) {
        obj[key] = this.contactsForm.get(`shippingNewContactData.${key}`).value;
      }
      obj.preferredContactMethod = this.contactsForm.get(
        'shippingNewContactData.preferredContactMethod3'
      ).value;
      obj['email'] = this.contactsForm.get(shippingContactEmail).value;
      obj['fax'] = this.contactsForm.get(shippingContactFax).value;
      this.formDetails.contacts.push(obj);
    }
  }

  replicateForm(flag) {
    if (flag == 'N') {
      this.isPrimaryFlag = false;
      this.contactsForm.markAsUntouched();
      this.contactsForm.get('primaryData').get('firstName_repeat').setValidators([Validators.required,
      Validators.pattern(nameRegex),
      Validators.maxLength(maxlengthChar)]);
      this.contactsForm.get('primaryData').get('lastname_repeat').setValidators([Validators.required,
      Validators.pattern(nameRegex),
      Validators.maxLength(maxlengthChar)]);
      this.contactsForm.get('primaryData').get('confirmEmail_repeat').setValidators([
        Validators.required,
        Validators.pattern(emailRegexExp),
      ]);
      this.contactsForm.get('primaryData').get('email_repeat').setValidators([
        Validators.required,
        Validators.pattern(emailRegexExp),
      ]);;
      this.contactsForm.get('primaryData').get('title_repeat').setValidators([Validators.required]);
      this.contactsForm.get('primaryData').get('firstName_repeat').updateValueAndValidity();
      this.contactsForm.get('primaryData').get('lastname_repeat').updateValueAndValidity();
      this.contactsForm.get('primaryData').get('confirmEmail_repeat').updateValueAndValidity();
      this.contactsForm.get('primaryData').get('email_repeat').updateValueAndValidity();
      this.contactsForm.get('primaryData').get('title_repeat').updateValueAndValidity();
      // this.contactsForm.get('primaryData').value.firstName_repeat.markAsUntouched();
      // this.contactsForm.get('primaryData').value.lastName_repeat.markAsUntouched();
      // this.contactsForm.get('primaryData').value.confirmEmail_repeat.markAsUntouched();
      // this.contactsForm.get('primaryData').value.email_repeat.markAsUntouched();
      // this.contactsForm.get('primaryData').value.datepicker_repeat.markAsUntouched();
      // this.contactsForm.get('primaryData').value.deaName_repeat.markAsUntouched();
      // this.contactsForm.get('primaryData').value.dea_repeat.markAsUntouched();
      // this.contactsForm.get('primaryData').value.hin_repeat.markAsUntouched();
      // this.contactsForm.get('primaryData').value.role_repeat.markAsUntouched();
      // this.contactsForm.get('primaryData').value.title_repeat.markAsUntouched();
      // this.contactsForm.get('primaryData').value.phone_repeat.markAsUntouched();
      // this.contactsForm.get('primaryData').value.extension_repeat.markAsUntouched();
      // this.contactsForm.get('primaryData').value.stateLicense_repeat.markAsUntouched();
    }
    else {
      this.isPrimaryFlag = true;


      this.contactsForm.get('primaryData').get('firstName_repeat').clearValidators();
      this.contactsForm.get('primaryData').get('lastname_repeat').clearValidators();
      this.contactsForm.get('primaryData').get('confirmEmail_repeat').clearValidators();
      this.contactsForm.get('primaryData').get('email_repeat').clearValidators();
      this.contactsForm.get('primaryData').get('title_repeat').clearValidators();
      this.contactsForm.get('primaryData').get('firstName_repeat').updateValueAndValidity();
      this.contactsForm.get('primaryData').get('lastname_repeat').updateValueAndValidity();
      this.contactsForm.get('primaryData').get('confirmEmail_repeat').updateValueAndValidity();
      this.contactsForm.get('primaryData').get('email_repeat').updateValueAndValidity();
      this.contactsForm.get('primaryData').get('title_repeat').updateValueAndValidity();

    }
  }
  ngOnDestroy() {
    this.contactTitleSub?.unsubscribe();
    this.contactRoleSub?.unsubscribe();
    this.accountRegisSub?.unsubscribe();
    this.subRecaptcha?.unsubscribe();
  }
  onlyNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return false;
  }

}